var $2dfc1dbb6590af88$exports = {};
$2dfc1dbb6590af88$exports = {
  "close": "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2");
      }
    }), ".");
  }
};
export { $2dfc1dbb6590af88$exports as default };